import React from 'react';

import Modal from 'react-modal';

const CreditReportModal = ({
  appId,
  showCreditReportModal,
  setShowCreditReportModal,
  creditReportCallback,
}) => {
  const handleCloseModal = (appId, setShowCreditReportModal) => {
    localStorage.setItem(appId + '_credit_unfreeze_shown', true);
    setShowCreditReportModal(false);
    creditReportCallback();
  };
  return (
    <Modal isOpen={showCreditReportModal} className="field-modal credit-report-modal sba">
      <div>
        <span className="close" onClick={() => handleCloseModal(appId, setShowCreditReportModal)}>
          x
        </span>
        <div className="modal-header">
          <h3>Credit Freezes and other Alerts</h3>
        </div>
        <div className="modal-content">
          <p>
            A credit freeze restricts access to your credit report, which means you — or others —
            won’t be able to open a new credit account while the freeze is in place. Although
            unfreezing your credit may not be required to prequalification purposes, it is necessary
            for final approval.
          </p>
          <p>
            If your credit is currently frozen, you can temporarily lift the credit freeze by
            contacting each credit bureau listed below
          </p>
          <p>Freezing and unfreezing your credit is FREE.</p>
          <div className="contact-number">
            <a href="https://www.experian.com/freeze/center.html" target="_blank" rel="noreferrer">
              Experian:
            </a>
            <div>(888) 397-3742</div>
          </div>
          <div className="contact-number">
            <a href="https://www.transunion.com/credit-freeze" target="_blank" rel="noreferrer">
              TransUnion:
            </a>
            <div>(888) 909-8872</div>
          </div>
          <div className="contact-number">
            <a
              href="https://www.equifax.com/personal/credit-report-services/credit-freeze/"
              target="_blank"
              rel="noreferrer"
            >
              Equifax:
            </a>
            <div>(800) 685-1111</div>
          </div>

          <a
            className="contact-number"
            href="https://consumer.ftc.gov/articles/what-know-about-credit-freezes-fraud-alerts"
            target="_blank"
            rel="noreferrer"
          >
            What to Know About Credit Freezes and Fraud Alerts
          </a>

          <div className="action-button">
            <button type="button" onClick={() => handleCloseModal(appId, setShowCreditReportModal)}>
              Close
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreditReportModal;
